<template>
  <strong>
    <a text @click="onTo" class='link-tag'>{{ text }}</a>
  </strong>
</template>

<script>
import router from "@/_router/index";

export default {
  props: ["text", "to"],
  name: "link-to",

  methods: {
    onTo() {
      router.push(this.to);
    },
  },

  router,
};
</script>

<style lang="scss" scoped>
.link-tag {
    text-decoration: underline;
}
</style>
